import React from 'react';

import { ExamSearch } from '../../components/Exam/ExamSearch';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';

interface ExamSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  initialOrderColumn?: string;
  initialOrderDirection?: 'DESC' | 'ASC';
  withFilterInColumns?: boolean;
}

export const ExamsInActiveView: React.FC<ExamSearchProps> = props => {
  return (
    <>
      <ExamSearch
        getData={props.getData}
        getCount={props.getCount}
        onRowClick={props.onRowClick}
        initialOrderColumn={props.initialOrderColumn}
        initialOrderDirection={props.initialOrderDirection}
        withFilterInColumns={props.withFilterInColumns}
      />
    </>
  );
};
